import React, { useState, useEffect } from 'react';
import './index.scss';
import Lottie from 'lottie-react';

const AdventureKorea250912: React.FC = () => {
    const [showForm, setShowForm] = useState(false);
    const [animationData, setAnimationData] = useState(null);

    const closeForm = () => {
        setShowForm(false);
        if (window.history.state?.formOpen) {
            window.history.back();
        }
    };

    useEffect(() => {
        // Fetch Lottie animation
        fetch('https://static.koreanmate.app/notice/250912-adventure-korea/friends.json')
            .then(response => response.json())
            .then(data => setAnimationData(data))
            .catch(error => console.error('Error loading animation:', error));
    }, []);

    useEffect(() => {
        const handlePopState = (e: PopStateEvent) => {
            if (!e.state?.formOpen && showForm) {
                setShowForm(false);
            }
        };

        const handleEscKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape' && showForm) {
                closeForm();
            }
        };

        window.addEventListener('popstate', handlePopState);
        if (showForm) {
            window.addEventListener('keydown', handleEscKey);
        }
        
        return () => {
            window.removeEventListener('popstate', handlePopState);
            window.removeEventListener('keydown', handleEscKey);
        };
    }, [showForm]);

    return (
        <div className="adventure-korea-page">
            {animationData && (
                <div className="lottie-container">
                    <Lottie 
                        animationData={animationData}
                        loop={true}
                        autoplay={true}
                        style={{ width: '100%', maxWidth: '400px', height: 'auto' }}
                    />
                </div>
            )}
            
            <div className="page-container">
                <img src="https://static.koreanmate.app/notice/250912-adventure-korea/01.jpg" alt="Adventure Korea Banner" className="page-image" />
            </div>
            
            <div className="page-container">
                <img src="https://static.koreanmate.app/notice/250912-adventure-korea/02.jpg" alt="Event Details" className="page-image" />
            </div>
            
            <div className="page-container">
                <img src="https://static.koreanmate.app/notice/250912-adventure-korea/03.jpg" alt="Register Now" className="page-image" />
            </div>
        </div>
    );
};

export default AdventureKorea250912;